<h4 class="pre_order_heading">
	PRE ORDER
</h4>
<p class="preOrderPara">An advance payment of 50% is required at checkout</p>
<div class="inner_pre_order">

	<fb-pre-order-price [productData]="productDataContainer" [preOrderQuantity]="preOrderQty"></fb-pre-order-price>

	<fb-bulk-login-and-share-and-addtostoryboard-container (openVolumeDiscount)="openVolumeDiscount()"
						*ngIf="productDataContainer.volumeDiscountProfileEnabled">
					</fb-bulk-login-and-share-and-addtostoryboard-container>

	<fb-volume-discount *ngIf="productData.volumeDiscountProfileEnabled && volumeDiscountclose"
						[unit]="productDataContainer.unit"
						[dataVolumeDiscount]="productDataContainer.volumeDiscountProfile!"
						(closeVolumeDiscountOption)="volumeDiscountclose = false; _globalService.popUpOpenClose(false);">
	</fb-volume-discount>

	<div class="customizeTrigger" (click)="triggerCustomizeOption()"
		 *ngIf="productData.fabricProfileEnabled
					|| productData.sizeProfileEnabled
					|| productData.fabricProfileEnabled ">
		<button class="
						{{isCustomizationOpen?'active':''}}
						{{isAnimationStopped?'animtion_stopped':''}}">
			<span>Customise {{isThisProductFabric?'This Fabric':'This Product'}}</span>
			<span class="material-symbols-outlined expand">expand_more</span>
		</button>
	</div>
	<div class="customization_container {{isCustomizationOpen?'active':''}}">
		<fb-choose-fabric *ngIf="productDataContainer.fabricProfileEnabled" [fabricData]="productDataContainer"
						  (imageTransferDisplayImage)="updateImageToDisplay($event)">
		</fb-choose-fabric>

		<ng-container *ngIf="productDataContainer.sizeProfileEnabled">
			<fb-choose-size [sizeData]="productDataContainer.sizeProfile!" sizeProfileOptionList
							[customSizeData]="productDataContainer.customSizeProfile!"
							[customSizeDataEnabled]="productDataContainer.customSizeProfileEnabled"
							[productSizeProfileList]="productDataContainer.productSizeProfileList!"
							[product]="productDataContainer"></fb-choose-size>
		</ng-container>


		<fb-select-finish *ngIf="productDataContainer.finishProfileEnabled"
						  [finishProfileData]="productDataContainer.finishProfile!"
						  [instockIds]="productDataContainer.finishProfileItemId"></fb-select-finish>
	</div>

	<fb-order-quantity [totalQuantityFromParent]="productDataContainer.totalQuantity"
					   [unitFromParent]="productDataContainer.unit"
					   [volumeDiscountProfile]="productDataContainer.volumeDiscountProfile?productDataContainer.volumeDiscountProfile:undefined"
					   *ngIf="productDataContainer.volumeDiscountProfileEnabled"
					   (sendQtyToCartButtonPreOrder)="preOrderQTYPassOn($event)">
	</fb-order-quantity>

</div>
<ng-container *ngIf="isUserLoggedIn">
	<div class="pre_order_now_cont_button">
		<button (click)="addToCartPreOrder()">
			PRE ORDER NOW
		</button>

		<p class="estimated_shpping_date">
			Estimated Shipping Date: {{preOrderDeliveryFromDate | formatDate}} - {{preOrderDeliveryToDate | formatDate}}
		</p>
	</div>
</ng-container>

<ng-container *ngIf="!isUserLoggedIn">
	<div class="pre_order_now_cont_button">
		<button routerLink="/auth/login">
			LOGIN TO PRE ORDER
		</button>
	</div>
</ng-container>

